import { getSocket } from '@src/App';

export default async (gameId: string, password?: string) => {
  try {
    const message: { gameId: string; password?: string } = { gameId };
    if (password) message.password = password;
    getSocket().emit('joinGame', message);
  } catch (e) {
    console.log(e);
  }
};
